import React, { useState, useEffect } from 'react';

import './styles.css';

import studentsServices from '../../../services/academy/studentsServices';

import compare from '../../../functions/compare';
import { months } from '../../../functions/formatDate';

import MainView from '../../../components/MainView';
import NavHistory from '../../../components/NavHistory';
import ActivityIndicator from '../../../components/ActivityIndicator';
import NotificationsGroup from './NotificationsGroup';

function Notifications() {
    const [notifications, setNotifications] = useState([]);
    const [fetching, setFetching] = useState(true);
    const [lidos, setLidos] = useState(false);
    const [showedNotifications, setShowedNotifications] = useState([]);

    useEffect(() => {
        readNotifications();
    }, []);

    useEffect(()=> {
        setShowedNotifications(notifications.filter(obj => obj.lido === lidos));
    }, [notifications, lidos]);

    async function readNotifications() {
        const id = localStorage.getItem("_id");
        const response = await studentsServices.getStudentNotifications(id);
        setFetching(false);
        if (response.status === 200) {
            setNotifications(response.data.sort((a, b) => compare(`${a.data}${a.hora}`, `${b.data}${b.hora}`, true)));
            console.log(response.data.map((item, index) => item.data.split(' ')));
        } else
            alert("Erro ao ler notificações, tente novamente!");
    }

    function findMonthGroupIndex(array, month) {
        return array.findIndex((item) => {
            return item.month === month;
        });
    }

    function groupByMonth(array) {
        return array.reduce((cache, item) => {
            const month = item.data.slice(0, 7);
            const index = findMonthGroupIndex(cache, month);
            if (index !== -1) {
                cache[index].notifications.push(item);
            } else {
                cache.push({
                    month: month,
                    notifications: [item]
                });
            }
            return cache;
        }, []).sort((a, b) => compare(a.month, b.month, true));
    }

    return (
        <MainView currentPage='notifications' studentMenu>
            <NavHistory navPages={['Notificações']} />

            <div className='notifications-page-buttons'>
                <button className={lidos ? 'notifications-page-button-not-selected' : ''} onClick={() => setLidos(false)}>Novas</button>
                <button className={!lidos ? 'notifications-page-button-not-selected' : ''} onClick={() => setLidos(true)}>Lidas</button>
            </div>

            {
                !fetching ?
                    <ul className='notifications-page-list'>
                        {
                            groupByMonth(showedNotifications).map((item, index) => {
                                const date = item.month.split('-').reverse();
                                const yearNow = new Date().toISOString().split('-')[0];
                                return <NotificationsGroup
                                    key={index}
                                    notificationsRef={months[date[0] - 1] + (date[1] !== yearNow ? ` de ${date[1]}` : "")}
                                    notificationsData={item.notifications}
                                    setNotifications={setNotifications}
                                />
                            })
                        }
                    </ul>
                    : <ActivityIndicator />
            }
        </MainView>
    )
}

export default Notifications;